import {findIndex} from 'lodash';
import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {Common, Accessories} from '../../common/actionTypes';
import {downloadFile} from '../../common/util/file';

const INITIAL_STATE = {
  'loadingOrders': false,
  'ordersList': [],
  'loadingChassis': false,
  'chassisList': [],
  'pageSize': 20,
  'pageNumber': 0,
  'itemsCount': 0,
  'filters': {
    'startDate': '',
    'endDate': '',
    'chassis': '',
    'order': '',
    'status': '',
    'outsourced': 'all',
  },
};

function updateStatusInOrder(list, orderInfo) {
  const newList = [...list];
  const index = findIndex(newList, {'order': orderInfo.order});
  const newObject = {...newList[index]};
  newObject.status = orderInfo.status;
  
  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
}

export const qualityAssuranceOrders = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_CHASSIS_AVAILABLE]: (state, action) => ({
      ...state,
      'loadingChassis': true,
    }),
    [ActionTypes.FETCHED_CHASSIS_AVAILABLE]: (state, action) => ({
      ...state,
      'loadingChassis': false,
      'chassisList': action.response.data,
    }),
    [ActionTypes.FETCHED_CHASSIS_AVAILABLE_FAILED]: (state, action) => ({
      ...state,
      'loadingChassis': false,
      'chassisList': [],
    }),
    [ActionTypes.FETCHING_QUALITY_ASSURANCE_ORDERS_LIST]: (state, action) => ({
      ...state,
      'loadingOrders': true,
    }),
    [ActionTypes.FETCHED_QUALITY_ASSURANCE_ORDERS_LIST]: (state, action) => ({
      ...state,
      'loadingOrders': false,
      'ordersList': action.response.data,
      'itemsCount': action.response.count,
    }),
    [ActionTypes.FETCHED_QUALITY_ASSURANCE_ORDERS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingOrders': false,
      'ordersList': [],
      'itemsCount': 0,
    }),
    [Common.CHANGE_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
    }),
    [Common.CHANGE_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
    }),
    [ActionTypes.CLOSED_QUALITY_ASSURANCE_ORDER]: (state, action) => ({
      ...state,
      'ordersList': updateStatusInOrder(state.ordersList, action.response.data),
    }),
    [Accessories.CANCELLED_ORDER]: (state, action) => ({
      ...state,
      'ordersList': updateStatusInOrder(state.ordersList, action.response.data),
    }),
    [ActionTypes.SET_QA_ORDERS_FILTER]: (state, action) => ({
      ...state,
      'filters': action.payload,
    }),
    [ActionTypes.CLEAR_QA_ORDERS_FILTER]: (state, action) => ({
      ...state,
      'filters': {
        'startDateFilter': '',
        'endDateFilter': '',
        'chassis': '',
        'order': '',
        'status': '',
        'outsourced': 'all',
      },
    }),
    [ActionTypes.EXPORTING_QUALITY_ASSURANCE_ORDERS_LIST]: (state, action) => ({
      ...state,
      'loadingOrders': true,
    }),
    [ActionTypes.EXPORTED_QUALITY_ASSURANCE_ORDERS_LIST]: (state, action) => {
      downloadFile(action.payload);
      return {
        ...state,
        'loadingOrders': false,
      };
    },
    [ActionTypes.EXPORTED_QUALITY_ASSURANCE_ORDERS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingOrders': false,
    }),
  })(state, action);
};
